import React, { useContext } from "react";
import { canv } from "@/canv/global";
import type { WidgetListItemValue } from "../types";
import { NewVoteContext } from "../VoteWindowLayout";
import { NewVoteController } from "./NewVoteController";
import { NewVoteSwitch } from "./NewVoteSwitch";
import { NewVoteWidgetsListItem } from "./NewVoteWidgetsListItem";
import style from "./newVote.module.css";

export function NewVote() {
    const { newVoteState: state, onUpdate, onStart, isGuest } = useContext(NewVoteContext);

    const handleUpdateWidgetItem = (type: WidgetListItemValue, value: boolean) => {
        const result = state.widgetsList.map((widget) => {
            if (widget.value === type) {
                return { ...widget, selectedCount: value ? widget.candidateCount : 0 };
            }

            canv.appInterface.voteWindow.screen?.selectByType(type, value);

            return widget;
        });

        onUpdate("widgetsList", result);
    };

    const disabledStartButton =
        Boolean(canv.canvasController.activeVote) ||
        (canv.appInterface.voteWindow.screen?.candidates.size as number) < 2 ||
        (canv.appInterface.voteWindow.screen?.selectedGroupUIDs.size as number) < 2;

    return (
        <div className={style.newVoteWrapper}>
            <div>
                <div className={style.newVoteControllersWrapper}>
                    <NewVoteController
                        name="Голоса"
                        description="на участника"
                        count={state.votesCount}
                        onChange={(n) => onUpdate("votesCount", state.votesCount + n)}
                        onInputChange={(n) => onUpdate("votesCount", n)}
                    />
                    <NewVoteController
                        name="Время"
                        description="в минутах"
                        count={state.timeCount}
                        onChange={(n) => onUpdate("timeCount", state.timeCount + n)}
                        onInputChange={(n) => onUpdate("timeCount", n)}
                    />
                </div>

                <div className={style.newVoteSwitchesWrapper}>
                    <NewVoteSwitch
                        name="По одному голосу на объект"
                        value={state.oneVotePerObject}
                        onChange={(val) => onUpdate("oneVotePerObject", val)}
                    />
                </div>

                <div className={style.newVoteWidgetsListWrapper}>
                    <p className={style.newVoteWidgetsListTitle}>Выбор объектов</p>
                    <div className={style.newVoteWidgetsList}>
                        {state.widgetsList.map((widget) => (
                            <NewVoteWidgetsListItem
                                key={widget.value}
                                name={widget.name}
                                value={widget.value}
                                selectCount={widget.selectedCount}
                                candidateCount={widget.candidateCount}
                                onSelect={(val) => handleUpdateWidgetItem(widget.value, val)}
                            />
                        ))}
                    </div>
                </div>
            </div>

            <div className={style.newVoteStartVoteButtonWrapper}>
                <button
                    type="button"
                    className={style.newVoteStartVoteButton}
                    onMouseDown={onStart}
                    disabled={disabledStartButton || isGuest}
                >
                    Начать голосование
                </button>
            </div>
        </div>
    );
}
